export const portfolios = {
  Web: [
    {
      type: "featured",
      name: "Tanishq",
      image: require("./image/Tanishq.jpeg"),
      description:
        "An E-Commerce Website Clone, Where users can order jewellery items through this website.",
      demo: "https://tanishqclone.herokuapp.com/index",
      source: "https://github.com/GYashvant/Tanishq",
      tools: [ "CSS", "MongoDB","EJS","JS"],
    },
    {
      type: "featured",
      name: "Yatra",
      image: require("./image/yatrapic.png"),
      description:
        "An online travel booking website, where users can compare prices and book a wide range of services catering to their travel needs.",
      demo: "https://yatraclone.herokuapp.com/",
      source: "https://github.com/Balkishan-Pal/Yatra",
      tools: [ "CSS", "React","MongoDB"]
    },

    {
      type: "featured",
      name: "Faballey",
      image: require("./image/faballey.png"),
      description:
        "An online cloth booking website, where users can choose a wide range of clothes catering to their fasion needs.",
      demo: "https://faballey-clone.herokuapp.com/",
      source: "https://github.com/Balkishan-Pal/Faballey.com",
      tools: [ "CSS", "React","MongoDB","Redux"]
    },


  ],
}
